/**
 * Detect whether a business category should use automotive-specific
 * booking intake (vehicle details, drop-off vs wait).
 */
export function isAutomotiveBusinessCategory(category: string | undefined | null): boolean {
  if (!category || typeof category !== 'string') return false;
  const lower = category.toLowerCase().trim();
  if (lower === 'automotive' || lower === 'auto') return true;
  if (lower.includes('automotive')) return true;
  if (lower.includes('auto service') || lower.includes('auto repair')) return true;
  if (lower.includes('mechanic') || lower.includes('car wash') || lower.includes('oil change')) {
    return true;
  }
  const normalized = lower.replace(/\s+/g, '_').replace(/&/g, 'and');
  return normalized.startsWith('automotive_');
}
